module.exports = __webpack_public_path__ + "static/media/noun_day_night.718490b2.svg";